import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "geo",
  "use": "geo-usage",
  "viewBox": "0 0 14 19",
  "content": "<symbol viewBox=\"0 0 14 19\" id=\"geo\"><path d=\"M7 0C3.14 0 0 3.138 0 6.995 0 8.001.206 8.962.612 9.85c1.75 3.827 5.106 7.867 6.093 9.014a.39.39 0 0 0 .59 0c.987-1.147 4.342-5.187 6.093-9.014A6.817 6.817 0 0 0 14 6.995C13.999 3.138 10.859 0 7 0zm0 10.628a3.639 3.639 0 0 1-3.636-3.633A3.639 3.639 0 0 1 7 3.361a3.639 3.639 0 0 1 3.636 3.634A3.639 3.639 0 0 1 7 10.628z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol